import { useEffect, useRef, useState } from "react";

import { loadKakao } from "../lib/kakao.js";

/* 안내문은 모듈 상수로 둔다. 렌더마다 새 배열을 만들면 setState 가 매번
   새 값으로 보여 재렌더 → 이펙트 재실행 → 무한 루프가 된다. */
const NO_COORDS = [
  "아직 좌표가 없어 지도를 그릴 수 없습니다.",
  "식권대장 캡처는 이름과 거리만 주기 때문입니다.",
  "`python3 -m collector.enrich`",
  "카카오 REST 키로 좌표를 채우면 지도가 켜집니다.",
  "리스트·기록·링크는 지금도 전부 동작합니다.",
];
const NO_KEY = [
  "지도를 보려면 카카오 JavaScript 키가 필요합니다.",
  "`web/.env.local` 의 VITE_KAKAO_JS_KEY 를 채우고 dev 서버를 다시 띄워주세요.",
  "리스트와 기록은 키 없이도 전부 동작합니다.",
];
const SDK_FAIL = [
  "카카오 지도 SDK를 불러오지 못했습니다.",
  "키와 플랫폼(Web) 도메인 등록을 확인해주세요.",
];

/**
 * 지도를 딱 한 번 만든다. 카카오 Map 인스턴스는 파괴 API가 없어서,
 * StrictMode 의 이펙트 두 번 실행에 그대로 노출되면 컨테이너를 두 번 갈아엎는다.
 */
export function useKakaoMap(containerRef, { center, apiKey, hasCoords }) {
  const [map, setMap] = useState(null);
  const [places, setPlaces] = useState(null);
  const [notice, setNotice] = useState(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current || !center) return;
    if (!hasCoords) return setNotice(NO_COORDS);
    if (!apiKey) return setNotice(NO_KEY);

    /* 취소 플래그(let alive)를 쓰면 안 된다. StrictMode 는 첫 이펙트를 즉시 청소하고
       다시 실행하는데, 그 사이 SDK 로드가 끝나면 결과가 통째로 버려지고 두 번째 실행은
       started 에 막혀 아무 일도 안 한다 → 지도가 영영 안 뜬다. 어차피 한 번만 만들고
       끝까지 들고 갈 인스턴스라 청소할 것도 없다. */
    started.current = true;
    loadKakao(apiKey).then((kakao) => {
      if (!containerRef.current) return;
      const m = new kakao.maps.Map(containerRef.current, {
        center: new kakao.maps.LatLng(center[0], center[1]),
        level: 4,
      });
      setMap(m);
      if (kakao.maps.services) setPlaces(new kakao.maps.services.Places());
      setNotice(null);
    }).catch(() => setNotice(SDK_FAIL));
  }, [center, apiKey, hasCoords, containerRef]);

  return { map, places, notice };
}
